<template>
  <div class="container">
    <div class="top-box">
      <div class="tb_h1">{{ info.Subject }}</div>
      <div class="tb_member" @click.stop="toHomePage">
        <van-image :src="info.Photo" fit="contain"></van-image>
        <div class="tbm_name">{{ info.NickName }}</div>
        <div class="tbm_btn" v-if="info.MemberId">进入主页</div>
      </div>
      <div class="tb_info">
        <div><span class="bold">单位名称： </span>{{ info.CompanyName }}</div>
        <div>
          <div class="bold">推荐理由：</div>
          <div class="wxParse" v-html="info.Summary"></div>
        </div>
      </div>
      <div class="tb_time">{{ info.AddTime }}</div>
    </div>
    <div class="other-box">
      <div class="ob_headline">其他推荐项目</div>
      <div
        class="ob_item"
        v-for="(item, index) in list"
        :key="index"
        @click="toPathHandle(item.ID)"
      >
        <div class="overFlowOne">{{ item.Subject }}</div>
        <div>
          <span>{{ item.AddTime }}</span
          ><span>{{ item.Click }}浏览</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { juryCommendArticleInfo, juryCommendArticleList } from "@/api/lighting";
import { Image } from "vant";
import { formatTimeDay } from "@/utils/date";
export default {
  name: "recDetail",
  components: {
    "van-image": Image,
  },
  data() {
    return {
      id: null,
      info: "",
      list: [],
    };
  },
  methods: {
    getInfo() {
      var that = this;
      var data = {
        Id: that.id,
      };
      juryCommendArticleInfo(data).then((res) => {
        res.Data.AddTime = formatTimeDay(res.Data.AddTime, "-");
        that.info = res.Data;
        that.getList();
      });
    },

    getList() {
      var that = this;
      var data = {
        AwardYear: that.awardYear,
        AwardMemebrId: that.info.AwardMemberID,
      };
      juryCommendArticleList(data).then((res) => {
        var list = res.Data.List;
        list.forEach((item, index) => {
          item.AddTime = formatTimeDay(item.AddTime, "-");
        });
        that.list = list;
      });
    },

    //跳转推荐详情
    toPathHandle(id) {
      window.location.href = "/recDetail?id=" + id;
    },

    //跳转个人中心
    toHomePage: function () {
      let mid = this.info.MemberId;
      if (mid) {
        this.$router.push({
          path: "/homePage",
          query: {
            mid: mid,
          },
        });
      }
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getInfo();
  },
};
</script>
<style scoped src="../../../static/css/recDetail.css">
</style>